import React from "react";
import { Link } from "react-router-dom";


const ArrowRight = () => (
  <svg className="cat-card-cta-arrow" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M1 6h10M7 1l5 5-5 5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const CornerSvg = () => (
  <svg className="cat-card-corner" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 2h32v32" stroke="white" strokeWidth="1.2" />
    <path d="M2 2v32h32" stroke="white" strokeWidth="0.5" strokeDasharray="3 3" />
    <circle cx="18" cy="18" r="5" stroke="white" strokeWidth="0.8" />
  </svg>
);

function Card({ category, cardRef }) {
  return (
    <div
      className={`cat-card ${category.featured ? "cat-card--featured" : "cat-card--regular"}`}
      ref={cardRef}
    >
      {/* Video hai toh video, warna image */}
      {category.video ? (
        <video
          className="cat-card-video"
          autoPlay
          muted
          loop
          playsInline
          aria-hidden="true"
        >
          <source src={category.video} type="video/mp4" />
        </video>
      ) : (
        <img
          src={category.image}
          alt={category.title}
          className="cat-card-video"   // same class — same CSS apply hogi
          loading="lazy"
        />
      )}

      <div className="cat-card-overlay" aria-hidden="true" />
      {category.featured && <CornerSvg />}

      <div className="cat-card-content">
        <span className="cat-card-tag">{category.label}</span>
        <h3 className="cat-card-title">{category.title}</h3>
        <Link to={category.route} className="cat-card-cta">
          Explore
          <ArrowRight />
        </Link>
      </div>
    </div>
  );
}


export default Card;



